"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _internal = require("@/components/uploadPicture/internal");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'CategoryDialog',
  props: {
    // 控制弹框显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 弹框标题
    dialogTitle: {
      type: String,
      default: '添加分类'
    },
    // 分类表单数据
    categoryForm: {
      type: Object,
      default: function _default() {
        return {
          id: null,
          pid: 0,
          name: '',
          extra: '',
          sort: 0,
          status: true
        };
      }
    },
    // 是否禁用上级分类选择框
    isParentSelectDisabled: {
      type: Boolean,
      default: false
    },
    // 上级分类选项（树形数据）
    parentCategoryOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      // 表单验证规则
      formRules: {
        name: [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }],
        pid: [{
          validator: function validator(rule, value, callback) {
            if (value === null || value === undefined || value === '') {
              callback(new Error('请选择上级分类'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序值',
          trigger: 'blur'
        }]
      },
      // 图片预览相关
      imagePreviewVisible: false,
      currentPreviewImage: '',
      // 级联选择器配置
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        // 启用部分选择，可以选择任意级别的节点
        emitPath: false,
        multiple: false,
        expandTrigger: 'hover',
        // 鼠标悬停展开
        lazy: false
      }
    };
  },
  watch: {
    // 监听父级分类选项的变化
    parentCategoryOptions: {
      handler: function handler(newVal) {
        console.log('CategoryDialog - parentCategoryOptions changed:', newVal);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 图标上传点击事件
    handleIconUpload: function handleIconUpload() {
      var _this = this;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        maxCount: 1,
        model: 'product',
        pid: 1,
        onSuccess: function onSuccess(url) {
          _this.$emit('icon-change', url);
          _this.$message.success('图标上传成功');
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '图标上传失败');
        }
      });
    },
    // 删除图标
    removeIcon: function removeIcon() {
      this.$emit('icon-change', '');
    },
    // 预览图标
    previewIcon: function previewIcon() {
      this.currentPreviewImage = this.categoryForm.extra;
      this.imagePreviewVisible = true;
    },
    // 处理图标上传（兼容旧版本）
    handleIconChange: function handleIconChange(file) {
      var _this2 = this;
      var isImage = file.raw.type.indexOf('image/') === 0;
      var isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('请上传图片格式的文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }

      // 创建预览URL
      var reader = new FileReader();
      reader.onload = function (e) {
        _this2.$emit('icon-change', e.target.result);
      };
      reader.readAsDataURL(file.raw);
    },
    // 处理取消
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    // 处理提交
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.categoryForm.validate(function (valid) {
        if (valid) {
          // 处理父级ID，由于启用了checkStrictly，pid直接就是选中的节点ID
          var formData = _objectSpread({}, _this3.categoryForm);
          // 确保pid是数字类型
          formData.pid = Number(formData.pid) || 0;
          _this3.$emit('submit', formData);
        }
      });
    },
    // 处理关闭
    handleClose: function handleClose() {
      this.$emit('close');
    },
    // 清除验证
    clearValidate: function clearValidate() {
      var _this4 = this;
      this.$nextTick(function () {
        if (_this4.$refs.categoryForm) {
          _this4.$refs.categoryForm.clearValidate();
        }
      });
    },
    // 分类搜索过滤方法
    filterCategories: function filterCategories(node, keyword) {
      if (!keyword) return true;
      return node.name.toLowerCase().includes(keyword.toLowerCase());
    },
    // 展开前回调，可以在这里进行权限控制或其他逻辑
    beforeExpand: function beforeExpand(node) {
      // 可以在这里添加展开前的验证逻辑
      return true;
    },
    // 处理分类选择变化
    handleCategoryChange: function handleCategoryChange(value) {
      console.log('选择的分类ID:', value);
      // 可以在这里添加选择后的额外逻辑
      this.$emit('category-change', value);
    }
  }
};